import { forEach } from "lodash";
import { element } from "prop-types";
import React, { useState } from "react";
import { useEffect } from "react";
import SubHead from "./SubHead";
import PopupEthicalPledge from "./components/PopupEthicalPledge";
import ManagementTab1 from "./components/ManagementTab1";
import ManagementTab2 from "./components/ManagementTab2";
import ManagementTab3 from "./components/ManagementTab3";

function Management() {
    const [currentTab, setCurrentTab] = useState(1);
    return (
        <>
            <SubHead title="윤리경영" eng="Ethical Management"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    {/* 탭 */}
                    <div className="sub_tab_wrap">
                        <ul className="sub_tab wide ethical-tab">
                            <li className={currentTab === 1 ? "on" : ""} onClick={e => setCurrentTab(1)}>
                                <a href="javascript:;">윤리경영</a>
                            </li>
                            <li className={currentTab === 2 ? "on" : ""} onClick={e => setCurrentTab(2)}>
                                <a href="javascript:;">제보하기</a>
                            </li>
                            {/* <li className={currentTab === 3 ? "on" : ""} onClick={e => setCurrentTab(3)}>
                                <a href="#tab3">처리결과 확인</a>
                            </li> */}
                        </ul>
                    </div>

                    {/* 탭 내용 */}
                    <div className="ethical-tab-contents">
                        {currentTab === 1 && <ManagementTab1 />}
                        {currentTab === 2 && <ManagementTab2 onChangeTab={tab => setCurrentTab(tab)} />}
                        {currentTab === 3 && <ManagementTab3 />}

                        {/* 윤리경영 */}
                        {/* <section id="tab1" className="tab-cont">
                            <div className="ethical-title">
                                <h2>1등 ktMOS 「新 윤리경영 원칙」</h2>
                                <h3>
                                    「우리는 글로벌 1등 기업으로 성장하기 위해 올바른 의사결정과 윤리적 판단으로 회사의 미래를 도모」한다.
                                    <br />
                                    이를 위해 「고객최우선, 준법경영, 기본충실, 주인의식, 사회적책임」을 모든 ktMOS인이 공유하고 지켜야할 윤리경영 5대 행동원칙으로 삼고, 이를 적극 실천할 것을 다짐한다.
                                </h3>
                            </div>
                            <div className="ethical-rules-wrap gray-back-bg">
                                <ul className="list">
                                    <li>
                                        <div className="icon n01"></div>
                                        <p className="sbj">
                                            원칙 <b>01</b>
                                        </p>
                                        <p className="txt">
                                            고객을 최우선 <br />
                                            가치로 삼는다.
                                        </p>
                                    </li>
                                    <li>
                                        <div className="icon n02"></div>
                                        <p className="sbj">
                                            원칙 <b>02</b>
                                        </p>
                                        <p className="txt">
                                            각종법규와 기준을 <br />
                                            엄격히 준수한다.
                                        </p>
                                    </li>
                                    <li>
                                        <div className="icon n03"></div>
                                        <p className="sbj">
                                            원칙 <b>03</b>
                                        </p>
                                        <p className="txt">
                                            기본과 원칙에 <br />
                                            충실한다.
                                        </p>
                                    </li>
                                    <li>
                                        <div className="icon n04"></div>
                                        <p className="sbj">
                                            원칙 <b>04</b>
                                        </p>
                                        <p className="txt">
                                            스스로 회사와 <br /> 내가 하나라는 주인 <br />
                                            의식을 가진다.
                                        </p>
                                    </li>
                                    <li>
                                        <div className="icon n05"></div>
                                        <p className="sbj">
                                            원칙 <b>05</b>
                                        </p>
                                        <p className="txt">
                                            국민기업으로서 <br />
                                            사회적 책임과 <br />
                                            의무를 다한다.
                                        </p>
                                    </li>
                                </ul>
                                <button type="button" onClick={popClassToggle} className="btn_nor red-line lg wide">
                                    新 윤리경영 원칙 전문보기
                                </button>
                            </div>
                        </section>*/}

                        {/* 제보하기 */}
                        {/* <section id="tab2" className="tab-cont">
                            <p className="tip-tit">
                                ktMOS 북부는 건전한 기업문화 조성 및 윤리경영의 실천을 위하여 채널 <b>(사이버 신문고)</b>을 운영하고 있습니다. ktMOS 북부 임직원의 비리행위를 제보하여 주시면 적극 조치할 것이며, 제보자의 신원은 철저히 보호됩니다.
                            </p>

                            <p className="red-sub-tit">제보유형</p>
                            <div className="tip-off-category">
                                <div className="example">
                                    <div className="title">
                                        <p>
                                            ※ ktMOS 북부 임직원의 <br />
                                            비리행위 이외에 서비스 이용 중 불편사항은 <br /> <b>“고객센터(1577-1535)”</b>로 접수하시면 <br /> 관련 부서에서 신속히 처리됩니다.
                                        </p>
                                    </div>
                                    <ul className="list">
                                        <li>임직원간 및 이해관계자 금품/향응 수수 및 공여</li>
                                        <li>회사 공금 횡령/유용 및 회사재산 파손</li>
                                        <li>기타 윤리강령에 위배되는 행위</li>
                                        <li>이해관계자에게 특혜 제공 또는 지분투자 행위</li>
                                        <li>고객 및 회사 정보 유츌</li>
                                        <li>이해관계자와 사적인 금전거래 및 부당한 압력 행사</li>
                                        <li>중복취업, 겸직 등 근무기강 관련 사항</li>
                                    </ul>
                                </div>
                                <div className="btns">
                                    <button type="button" onClick={popClassToggle} className="btn_nor red-line wide lg">
                                        ktMOS 북부 <b>윤리강령 보기</b>
                                    </button>
                                </div>
                            </div>

                            <p className="red-sub-tit">제보방법</p>
                            <table className="tbl_normal white wAuto">
                                <colgroup>
                                    <col width="20%" />
                                    <col width="auto" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>웹(WEB)</th>
                                        <td className="textL">ktMOS 북부 홈페이지 &gt; 윤리경영 &gt; 사이버 신문고 제보하기</td>
                                    </tr>
                                    <tr>
                                        <th>E-mail</th>
                                        <td className="textL">clean365.ktc@kt.com</td>
                                    </tr>
                                    <tr>
                                        <th>서신</th>
                                        <td className="textL">서울시 강남구 광평로 47길 28. KT수서빌딩 1층 ktMOS북부 윤리경영실</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="table-bottom-btns">
                                <button type="button" className="btn_nor red wide lg">
                                    사이버 신문고 제보하기
                                </button>
                                <button type="button" className="btn_nor red-line wide lg">
                                    처리결과 확인
                                </button>
                            </div>

                            <p className="red-sub-tit">제보운영</p>
                            <p className="text01">
                                윤리 위반 신고는 실명으로 접수하신 경우에 조사하는 것을 원칙으로 하고 있으며, 익명의 내용이라도 내용이 구체적이고 사실근거가 명확한 경우에는 조사를 실시합니다. 사실에 근거하지 않은 비방, 개인 사생활과 관련된 사항은 처리되지 않으며, ktMOS 북부 임직원의 비리행위 이외의
                                경우에는 답변을 생략하오니 이점 양지하여 주시기 바랍니다. 제보자의 신분과 제시한 증거, 제보내용은 엄격히 보호되고 있습니다.
                            </p>

                            <div className="ethical-seperate-line">
                                <span></span>
                            </div>

                            <div className="board-upload-table">
                                <table className="tbl_upload">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="35%" />
                                        <col width="15%" />
                                        <col width="35%" />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>
                                                <label>게시글 유형</label>
                                            </th>
                                            <td colSpan={3}>
                                                <span>
                                                    <input type="radio" name="write" id="normal_write" />
                                                    <label htmlFor="normal_write">실명으로 제보하기</label>
                                                </span>
                                                <span>
                                                    <input type="radio" name="write" id="secret_write" />
                                                    <label htmlFor="secret_write">익명으로 제보하기</label>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                <label htmlFor="upload-name">이름</label>
                                            </th>
                                            <td>
                                                <input type="text" className="text_nor w100" id="upload-name" />
                                            </td>
                                            <th>
                                                <label htmlFor="upload-email">이메일</label>
                                            </th>
                                            <td>
                                                <input type="email" className="text_nor w100" id="upload-email" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                <label htmlFor="upload-cell">핸드폰</label>
                                            </th>
                                            <td>
                                                <input type="text" className="text_nor w100" id="upload-cell" />
                                            </td>
                                            <th>
                                                <label htmlFor="upload-phone">일반전화</label>
                                            </th>
                                            <td>
                                                <input type="text" className="text_nor w100" id="upload-phone" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                <label>내용입력</label>
                                            </th>
                                            <td colSpan={3}>
                                                <div className="f-row">
                                                    <input type="text" className="text_nor f-grow" />
                                                    <span className="f-shrink">
                                                        <label>
                                                            <input type="checkbox" /> 이 글을 상단에 고정합니다.
                                                        </label>
                                                    </span>
                                                </div>
                                                <div className="edit_box">
                                                    <textarea className="textarea_nor" placeholder="내용입력" style={{ height: "180px" }}></textarea>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                <label htmlFor="upload-edit">첨부파일</label>
                                            </th>
                                            <td colSpan={3}>
                                                <div className="f-row">
                                                    <input type="file" className="text_nor f-grow" id="upload-edit" />
                                                    <button type="button" className="btn_nor md f-shrink black">
                                                        삭제
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="password-alt">
                                    <p>
                                        비밀게시글 처리결과 확인을 위해서는 '비밀번호'가 반드시 필요합니다.
                                        <br />
                                        정보를 먼저 작성하신 후 계속해서 이용해 주시기 바랍니다.
                                    </p>
                                </div>

                                <table className="tbl_upload">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="35%" />
                                        <col width="15%" />
                                        <col width="35%" />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>
                                                <label htmlFor="upload-pwd">비밀번호</label>
                                            </th>
                                            <td colSpan={3}>
                                                <input type="password" className="text_nor" id="upload-pwd" placeholder="비밀번호 (8자리이상 영문/숫자/특수문자 혼합)" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                <label htmlFor="upload-pwd2">비밀번호 확인</label>
                                            </th>
                                            <td colSpan={3}>
                                                <input type="password" className="text_nor" id="upload-pwd2" placeholder="비밀번호확인" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <p className="red-sub-tit">
                                개인정보 수집 동의
                                <span className="checks">
                                    <input type="checkbox" id="agree" />
                                    <label htmlFor="agree">아래 사항에 동의합니다.</label>
                                </span>
                            </p>
                            <div className="privacy-agree-wrap">
                                <p className="tit">개인정보 수집 및 이용목적</p>
                                <div className="text-wrap">
                                    윤리 위반 신고는 실명으로 접수하신 경우에 조사하는 것을 원칙으로 하고 있으며, 익명의 내용이라도 내용이 구체적이고 사실근거가 명확한 경우에는 조사를 실시합니다. 사실에 근거하지 않은 비방, 개인 사생활과 관련된 사항은 처리되지 않으며, ktMOS 북부 임직원의 비리행위
                                    <br />
                                    이외의 경우에는 답변을 생략하오니 이점 양지하여 주시기 바랍니다. 제보자의 신분과 제시한 증거, 제보내용은 엄격히 보호되고 있습니다.
                                    <br />
                                    윤리 위반 신고는 실명으로 접수하신 경우에 조사하는 것을 원칙으로 하고 있으며, 익명의 내용이라도 내용이 구체적이고 사실근거가 명확한 경우에는 조사를 실시합니다. 사실에 근거하지 않은 비방, 개인 사생활과 관련된 사항은 처리되지 않으며, ktMOS 북부 임직원의 비리행위
                                    <br />
                                    이외의 경우에는 답변을 생략하오니 이점 양지하여 주시기 바랍니다. 제보자의 신분과 제시한 증거, 제보내용은 엄격히 보호되고 있습니다.
                                    <br />
                                    윤리 위반 신고는 실명으로 접수하신 경우에 조사하는 것을 원칙으로 하고 있으며, 익명의 내용이라도 내용이 구체적이고 사실근거가 명확한 경우에는 조사를 실시합니다. 사실에 근거하지 않은 비방, 개인 사생활과 관련된 사항은 처리되지 않으며, ktMOS 북부 임직원의 비리행위
                                    <br />
                                    이외의 경우에는 답변을 생략하오니 이점 양지하여 주시기 바랍니다. 제보자의 신분과 제시한 증거, 제보내용은 엄격히 보호되고 있습니다.
                                    <br />
                                    윤리 위반 신고는 실명으로 접수하신 경우에 조사하는 것을 원칙으로 하고 있으며, 익명의 내용이라도 내용이 구체적이고 사실근거가 명확한 경우에는 조사를 실시합니다. 사실에 근거하지 않은 비방, 개인 사생활과 관련된 사항은 처리되지 않으며, ktMOS 북부 임직원의 비리행위
                                    <br />
                                    이외의 경우에는 답변을 생략하오니 이점 양지하여 주시기 바랍니다. 제보자의 신분과 제시한 증거, 제보내용은 엄격히 보호되고 있습니다.
                                    <br />
                                </div>
                                <div className="btns">
                                    <button type="button" className="btn_nor red-line wide lg">
                                        접수하기
                                    </button>
                                </div>
                            </div>
                        </section> */}

                        {/* 처리결과 확인 */}
                        {/* <section id="tab3" className="tab-cont">
                            <p className="process-confirm-text">
                                온라인 제보에 대한 접수 현황 및 저리상태를 확인하실 수 있습니다.
                                <br />
                                <b>※ 제보 접수 시 발급받으신 접수번호와 설정하신 비밀번호를 입력해 주세요</b>
                            </p>

                            <div className="process-confirm-wrap">
                                <div className="cols">
                                    <label htmlFor="number" className="import">
                                        접수번호
                                    </label>
                                    <input type="number" className="text_nor lg" id="number" placeholder="접수번호" />
                                </div>
                                <div className="cols">
                                    <label htmlFor="pwd" className="import">
                                        비밀번호
                                    </label>
                                    <input type="password" className="text_nor lg" id="pwd" placeholder="비밀번호" />
                                </div>
                            </div>

                            <div className="board-detail-btns">
                                <button type="button" className="btn_nor red-line wide lg">
                                    확인하기
                                </button>
                            </div>*/}

                        {/* ----------------- 처리결과 확인하기 버튼 누르면 나오는 화면 --------------- */}
                        {/* <p className="ethical-process-text">***님께서 2022년 12월 01일 신청하신 민원이 접수되었습니다.</p>

                            <table className="tbl_normal wAuto">
                                <colgroup>
                                    <col width="15%" />
                                    <col width="auto" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>신청번호</th>
                                        <td className="textL">20224257</td>
                                    </tr>
                                    <tr>
                                        <th>민원제목</th>
                                        <td className="textL">민원처리 부탁드립니다.</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="ethical-txt-sm">* 민원처리에 대한 답변은 **** 처리됩니다.</p>

                            <div className="board-detail-btns">
                                <button type="button" className="btn_nor red-line wide lg">
                                    내 민원보기
                                </button>
                            </div> */}

                        {/* ----------------- 내 민원보기 누르면 나오는 화면 --------------- */}
                        {/* <table className="tbl_upload">
                                <colgroup>
                                    <col width="15%" />
                                    <col width="auto" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>게시글 유형</th>
                                        <td>비밀글</td>
                                    </tr>
                                    <tr>
                                        <th>이름</th>
                                        <td>홍길동</td>
                                    </tr>
                                    <tr>
                                        <th>핸드폰</th>
                                        <td>010-0000-****</td>
                                    </tr>
                                    <tr>
                                        <th>제목</th>
                                        <td>민원처리 부탁드립니다.</td>
                                    </tr>
                                    <tr>
                                        <th>내용</th>
                                        <td>
                                            ************************
                                            <br />
                                            ************************
                                            <br />
                                            ************************
                                            <br />
                                            ************************
                                            <br />
                                            ************************
                                            <br />
                                            ************************
                                            <br />
                                            ************************ ************************
                                            <br />
                                            ************************
                                            <br />
                                            ************************
                                            <br />
                                            ************************
                                            <br />
                                            ************************
                                            <br />
                                            ************************
                                            <br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>첨부파일</th>
                                        <td>첨부파일 없음</td>
                                    </tr>
                                </tbody>
                            </table>
                        </section> */}
                    </div>
                </div>
            </main>
        </>
    );
}

export default Management;
